import { Link, useNavigate } from 'react-router-dom';
import './Header.css';
import ThemeToggle from './ThemeToggle';
import { useTheme } from '../hooks/useTheme.js';
import { useAuth } from '../context/AuthContext';

function Header() {
	const { isDarkMode } = useTheme();
	const navigate = useNavigate();
	const { userData } = useAuth();

	const handleDashboardClick = () => {
		if (userData) {
			navigate('/dashboard');
		} else {
			navigate('/dashboard/login');
		}
	};

	return (
		<header className='main-header'>
			<div className='header-left'>
				<img
					src={require(`../assets/Assemblie_FullIcon.png`)}
					alt='Assemblie Logo'
					className='logo'
				/>
			</div>
			<div className='header-right'>
				<nav>
					<Link to='/'>Home</Link>
					<Link to='/about'>About</Link>
					<Link to='/contact'>Contact</Link>
				</nav>
				<button
					className='dashboard-btn'
					onClick={handleDashboardClick}>
					Dashboard
				</button>
				<ThemeToggle />
			</div>
		</header>
	);
}

export default Header;
